import create from 'zustand';

export const useGlobalStore = create(set => ({
  isSideMenuActive: false,
  setSideMenuActive: isSideMenuActive => set(() => ({ isSideMenuActive }))
}));
